import { useMemo } from 'react'
import { useRouter } from 'next/router'

import { getModuleByPathOnURL } from 'utils/module'

export function useImpactoModule() {
  const { asPath } = useRouter()

  const MODULE = useMemo(() => {
    const moduleOnUrl = asPath.split('/')[1]
    return getModuleByPathOnURL(moduleOnUrl)
  }, [asPath])

  return MODULE
}
